import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AdviceCard',
  props: {
    advice: null,
    condensed: null,
    isTargetBlank: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers,
      i18n = _useNuxt2App.i18n;
    var getTwicPicImg = function getTwicPicImg(image) {
      var _image$fields, _image$fields$file;
      return (image === null || image === void 0 ? void 0 : (_image$fields = image.fields) === null || _image$fields === void 0 ? void 0 : (_image$fields$file = _image$fields.file) === null || _image$fields$file === void 0 ? void 0 : _image$fields$file.url) || (image === null || image === void 0 ? void 0 : image.url) || '';
    };
    var route = useRoute();
    var mainImage = computed(function () {
      var _props$advice$fields, _props$advice, _fields$mainImage, _fields$carousel;
      var fields = (_props$advice$fields = (_props$advice = props.advice) === null || _props$advice === void 0 ? void 0 : _props$advice.fields) !== null && _props$advice$fields !== void 0 ? _props$advice$fields : props.advice;
      if (!fields) {
        return '';
      }
      return getTwicPicImg((_fields$mainImage = fields.mainImage) !== null && _fields$mainImage !== void 0 ? _fields$mainImage : (_fields$carousel = fields.carousel) === null || _fields$carousel === void 0 ? void 0 : _fields$carousel[0]);
    });
    var mainAttribute = computed(function () {
      var _props$advice2, _props$advice2$fields, _props$advice3, _props$advice3$parent, _props$advice4, _props$advice4$fields, _props$advice4$fields2, _props$advice4$fields3;
      // If recipe has 'category' field, that means data is coming from Attraqt so this has priority
      var attraqtCategory = props === null || props === void 0 ? void 0 : (_props$advice2 = props.advice) === null || _props$advice2 === void 0 ? void 0 : (_props$advice2$fields = _props$advice2.fields) === null || _props$advice2$fields === void 0 ? void 0 : _props$advice2$fields.category;
      if (attraqtCategory) return attraqtCategory;

      // If recipe has 'parentAdviceListingPage' field, that means data is coming from GraphQL so this has priority
      var category = (props === null || props === void 0 ? void 0 : (_props$advice3 = props.advice) === null || _props$advice3 === void 0 ? void 0 : (_props$advice3$parent = _props$advice3.parentAdviceListingPage) === null || _props$advice3$parent === void 0 ? void 0 : _props$advice3$parent.title) || (props === null || props === void 0 ? void 0 : (_props$advice4 = props.advice) === null || _props$advice4 === void 0 ? void 0 : (_props$advice4$fields = _props$advice4.fields) === null || _props$advice4$fields === void 0 ? void 0 : (_props$advice4$fields2 = _props$advice4$fields.parentAdviceListingPage) === null || _props$advice4$fields2 === void 0 ? void 0 : (_props$advice4$fields3 = _props$advice4$fields2.fields) === null || _props$advice4$fields3 === void 0 ? void 0 : _props$advice4$fields3.title);
      if (category) return category;
    });
    var isAdviceHasSlug = computed(function () {
      var _props$advice5, _props$advice5$fields, _props$advice6;
      return Boolean((_props$advice5 = props.advice) === null || _props$advice5 === void 0 ? void 0 : (_props$advice5$fields = _props$advice5.fields) === null || _props$advice5$fields === void 0 ? void 0 : _props$advice5$fields.slug) || Boolean((_props$advice6 = props.advice) === null || _props$advice6 === void 0 ? void 0 : _props$advice6.slug);
    });
    var adviceLink = computed(function () {
      var _props$advice$fields$, _props$advice7, _props$advice7$fields, _props$advice8;
      return app.localePath({
        name: 'page-slug',
        params: {
          slug: (_props$advice$fields$ = (_props$advice7 = props.advice) === null || _props$advice7 === void 0 ? void 0 : (_props$advice7$fields = _props$advice7.fields) === null || _props$advice7$fields === void 0 ? void 0 : _props$advice7$fields.slug) !== null && _props$advice$fields$ !== void 0 ? _props$advice$fields$ : (_props$advice8 = props.advice) === null || _props$advice8 === void 0 ? void 0 : _props$advice8.slug
        }
      });
    });
    var title = computed(function () {
      var _props$advice$fields$2, _props$advice9, _props$advice9$fields, _props$advice0;
      return (_props$advice$fields$2 = (_props$advice9 = props.advice) === null || _props$advice9 === void 0 ? void 0 : (_props$advice9$fields = _props$advice9.fields) === null || _props$advice9$fields === void 0 ? void 0 : _props$advice9$fields.title) !== null && _props$advice$fields$2 !== void 0 ? _props$advice$fields$2 : (_props$advice0 = props.advice) === null || _props$advice0 === void 0 ? void 0 : _props$advice0.title;
    });
    var pageUrl = route.fullPath;
    return {
      __sfc: true,
      props: props,
      app: app,
      $trackers: $trackers,
      i18n: i18n,
      getTwicPicImg: getTwicPicImg,
      route: route,
      mainImage: mainImage,
      mainAttribute: mainAttribute,
      isAdviceHasSlug: isAdviceHasSlug,
      adviceLink: adviceLink,
      title: title,
      pageUrl: pageUrl,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});